import { CSSProperties, ReactNode } from "react"
import { CohortSyncPathCohortFragment, ResourceFragment } from "@pathwright/graphql-client/src/generated"
import BackgroundImage, { BackgroundImageProps } from "./BackgroundImage"

type ResourceBackgroundResource = (
  | NonNullable<CohortSyncPathCohortFragment["resource"]>
  | ResourceFragment
) & {
  blurred_background?: string | null
  cover_background_image?: string | null
  cover_blurred_background?: string | null
}

type ResourceBackgroundProps = {
  resource: ResourceBackgroundResource | null
  className?: string
  style?: CSSProperties
  children?: ReactNode
  overlay?: string
  forceBlur?: boolean
} & Omit<BackgroundImageProps, "image" | "overlay" | "children">

const ResourceBackground = ({
  resource,
  overlay,
  forceBlur,
  children,
  ...backgroundImageProps
}: ResourceBackgroundProps) => {
  if (!resource) {
    return null
  }

  const blurredBackground =
    resource.cover_blurred_background || resource.blurred_background
  const image =
    forceBlur && blurredBackground
      ? blurredBackground
      : resource.cover_background_image || resource.background_image || undefined

  // Use resource's background overlay if none provided
  const finalOverlay = overlay || resource.background_overlay || undefined

  return (
    <BackgroundImage
      image={image}
      overlay={finalOverlay}
      className="ResourceBackground BackgroundImage"
      {...backgroundImageProps}
    >
      {children}
    </BackgroundImage>
  )
}

ResourceBackground.displayName = "ResourceBackground"

export default ResourceBackground
